<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div :class="{modalContent: true}">
        <h4 v-if="type === 'move'">Move Content</h4>
        <h4 v-if="type === 'copy'">Copy Content</h4>
        <h4 v-if="type === 'link'">Link to Directory</h4>
        <div class="loadingCategory" v-if="loading"></div>
        <div class="categoryCnt" v-else>
          <div v-for="(item, i) in categories" :key="i">
            <div :class="{categoryItem: true, active: item.id === currentCategoryId,
              eventDir: item.isEventDir}"
              v-on:click="currentCategoryId = item.id; toggleSubmenu(item)">
              <h5>{{item.name[lang]}}</h5>
              <div class="ddHandle" :class="{open: item.openSubmenu}"
                v-if="item.submenu && item.submenu.length > 0"
                v-on:click.stop="toggleSubmenu(item, true)"></div>
            </div>
            <div v-if="item.submenu && item.submenu.length > 0">
              <div class="categorySubs" v-for="(s, i2) in item.submenu" :key="i2"
                :class="{open: item.openSubmenu}">
                <div :class="{categoryItem: true, subItem: true,
                  active: s.id === currentCategoryId, eventDir: s.isEventDir}"
                  v-on:click="currentCategoryId = s.id; toggleSubmenu(s);">
                  <div class="submenuIcon"></div>
                  <h5>{{s.name[lang]}}</h5>
                  <div class="ddHandle" :class="{open: s.openSubmenu}"
                    v-if="s.submenu && s.submenu.length > 0"
                    v-on:click.stop="toggleSubmenu(s, true)"></div>
                </div>
                <div v-if="s.submenu && s.submenu.length > 0">
                  <div class="categorySubs" v-for="(s2, i3) in s.submenu" :key="i3"
                    :class="{open: s.openSubmenu}">
                    <div :class="{categoryItem: true, subItem: true,
                      active: s2.id === currentCategoryId, eventDir: s2.isEventDir}"
                      v-on:click="currentCategoryId = s2.id; toggleSubmenu(s2);">
                      <div class="submenuIcon"></div>
                      <h5>{{s2.name[lang]}}</h5>
                      <div class="ddHandle" :class="{open: s2.openSubmenu}"
                        v-if="s2.submenu && s2.submenu.length > 0"
                        v-on:click.stop="toggleSubmenu(s2, true)"></div>
                    </div>
                    <div v-if="s2.submenu && s2.submenu.length > 0">
                      <div class="categorySubs" v-for="(s3, i4) in s2.submenu" :key="i4"
                        :class="{open: s2.openSubmenu}">
                        <div :class="{categoryItem: true, subItem: true,
                          active: s3.id === currentCategoryId, eventDir: s3.isEventDir}"
                          v-on:click="currentCategoryId = s3.id; toggleSubmenu(s3);">
                          <div class="submenuIcon"></div>
                          <h5>{{s3.name[lang]}}</h5>
                          <div class="ddHandle" :class="{open: s3.openSubmenu}"
                            v-if="s3.submenu && s3.submenu.length > 0"
                            v-on:click.stop="toggleSubmenu(s3, true)"></div>
                        </div>
                        <div v-if="s3.submenu && s3.submenu.length > 0">
                          <div class="categorySubs" v-for="(s4, i5) in s3.submenu" :key="i5"
                            :class="{open: s3.openSubmenu}">
                            <div :class="{categoryItem: true, subItem: true,
                              active: s4.id === currentCategoryId, eventDir: s4.isEventDir}"
                              v-on:click="currentCategoryId = s4.id; toggleSubmenu(s4);">
                              <div class="submenuIcon"></div>
                              <h5>{{s4.name[lang]}}</h5>
                              <div class="ddHandle" :class="{open: s4.openSubmenu}"
                                v-if="s4.submenu && s4.submenu.length > 0"
                                v-on:click.stop="toggleSubmenu(s4, true)"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modalAction">
          <button class="btn btnSecondary" v-on:click="close()"
            v-if="!btnDisabled">Cancel</button>
          <button :class="{btn: 1, btnPrimary: 1, disabled: btnDisabled}" v-on:click="moveNow">
            <template v-if="type === 'move'">
              <span v-if="btnDisabled">Moving content...</span>
              <span v-else>Move</span>
            </template>
            <template v-if="type === 'copy'">
              <span v-if="btnDisabled">Copying content...</span>
              <span v-else>Copy</span>
            </template>
            <template v-if="type === 'link'">
              <span v-if="btnDisabled">Creating link...</span>
              <span v-else>Create Link</span>
            </template>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'confirmation',
  data() {
    return {
      show: false,
      next: null,
      itemId: null,
      loading: true,
      btnDisabled: false,
      currentCategoryId: null,
      categories: [],
      type: 'move',
    };
  },
  computed: {
    ...mapState(['lang']),
  },
  methods: {
    open(d, next) {
      this.item = d.item;
      this.currentCategoryId = d.currentCategoryId;
      this.type = d.type || 'move';
      this.show = true;
      this.next = next;
      if (this.categories.length < 1) this.getCategories();
      document.getElementsByTagName('BODY')[0].classList.add('stopscroll');
    },
    close(b) {
      this.show = false;
      document.getElementsByTagName('BODY')[0].classList.remove('stopscroll');
      if (this.next && typeof this.next === 'function') this.next(b);
    },
    toggleSubmenu(item, fromHandle) {
      if (fromHandle) {
        // eslint-disable-next-line
        item.openSubmenu = !item.openSubmenu;
      } else if (!item.openSubmenu) {
        // eslint-disable-next-line
        item.openSubmenu = true;
      }
    },
    moveNow() {
      this.btnDisabled = true;
      const uri = `article/${this.item.id}/${this.type}/${this.currentCategoryId}`;
      this.$http.get(this.$config.uri(uri)).then((response) => {
        this.btnDisabled = false;
        this.close(true);
      });
    },
    getCategories() {
      this.loading = true;
      const uri = `article/directory?static=${this.item.parent.isStatic}`;
      this.$http.get(this.$config.uri(uri)).then((response) => {
        this.loading = false;
        this.categories = (response.data.status === 200) ? response.data.data : [];
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 40px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      width: 380px;
      &.hasCheck{
        text-align: left;
      }
      h4{
        margin: -30px -40px 0;
        padding: 14px 40px 10px;
        border-bottom: #eee 1px solid;
        font-size: 24px;
        font-weight: normal;
        color: #444;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .loadingCategory{
        height: 180px;
        background-image: url(../assets/loading-2.svg);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 40px auto;
      }
      .categoryCnt{
        padding: 10px 40px;
        height: 400px;
        overflow-y: auto;
        margin: 0 -40px;
        .categorySubs{
          padding-left: 10px;
          display: none;
          &.open{
            display: block;
          }
        }
        .categoryItem{
          margin: 0 -16px;
          padding: 7px 16px 8px;
          border-radius: 5px;
          margin-bottom: 5px;
          cursor: pointer;
          padding-left: 66px;
          position: relative;
          transition: all .3s ease;
          &:before{
            content: "";
            position: absolute;
            left: 34px; top: 10px;
            width: 20px; height: 20px;
            background-image: url(../assets/directory.png);
            background-size: cover;
            background-position: center;
            transition: all .3s ease;
            opacity: .6;
          }
          &:hover{
            background-color: #f5f5fe;
          }
          &.eventDir{
            position: relative;
            &:after{
              content: "";
              position: absolute;
              left: 44px; bottom: 6px;
              background-color: #0e5dd2;
              border-radius: 50%;
              width: 8px; height: 8px;
              border: #fff 2px solid;
              opacity: 1;
              z-index: 3;
            }
            &:hover:after{
              border-color: #eee;
            }
          }
          h5{
            font-weight: normal;
            font-size: 20px;
            margin: 0;
          }
          .ddHandle{
            padding: 0; margin: 0;
            position: absolute;
            width: 26px; height: 26px;
            left: 4px; top: 50%;
            margin-top: -13px;
            border-radius: 50%;
            background-size: 12px auto;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url(../assets/down-arrow.png);
            transform: rotate(-90deg);
            opacity: .5;
            transition: all .3s ease;
            &.open{
              transform: none;
            }
            &:hover{
              opacity: .7;
              background-color: rgba(0,0,0,.1);
            }
          }
          &.active{
            color: #fff;
            background-color: #0057d8;
            .ddHandle{
              filter: invert(1);
              opacity: 1;
            }
            &:before{
              filter: invert(1);
              opacity: 1;
              background-image: url(../assets/directory-open.png);
            }
            &.subItem{
              .submenuIcon{
                background-color: #fff;
                &:before{
                  background-color: #fff;
                }
              }
            }
          }
        }
      }
      p{
        margin: 0;
        color: #767676;
      }
      .checkCnt{
        margin: 20px 0 6px;
        position: relative;
        padding-left: 28px;
        cursor: pointer;
        p{
          color: red;
        }
        .checkboxOuter{
          position: absolute;
          left: -8px; top: -6px;
          width: 32px; height: 32px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          &:hover{
            background-color: #eee;
          }
          .checkbox{
            width: 14px; height: 14px;
            border-radius: 3px;
            border: #999 2px solid;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all .2s ease;
            &.checked{
              border-color: red !important;
              background-color: red !important;
              background-image: url(../assets/checked.png);
              background-size: 14px auto;
              background-position: center;
              background-repeat: no-repeat;
              .checkInner{
              }
            }
          }
        }
        &:hover{
          .checkboxOuter{
            .checkbox{
              border-color: #444;
            }
          }
        }
      }
      .modalAction{
        margin: 0 -40px -30px;
        padding: 10px 20px;
        text-align: right;
        // background-color: #eee;
        border-top: #eee 1px solid;
        .btn{
          margin-left: 10px;
          &.disabled{
            background-color: #ddd;
            color: #999;
            box-shadow: none;
            cursor: default;
          }
        }
      }
    }
  }
</style>
